import { render, staticRenderFns } from "./RateEditAdmin.vue?vue&type=template&id=cb05380c&"
import script from "./RateEditAdmin.vue?vue&type=script&lang=js&"
export * from "./RateEditAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports